/**
 * URL base del microservicio v1.
 *
 * - `REACT_APP_API_URL` definida → se respeta (producción: siempre definir la URL real del API).
 * - Valor relativo `/api/v1` (Docker/nginx mismo origen) → sin cambio.
 * - `REACT_APP_API_URL` apunta a localhost pero abres el front por IP en LAN → se sustituye el host
 *   para que otra máquina no llame a su propio localhost.
 * - Sin variable: en desarrollo o IP privada (LAN) → `http://<mismo-host>:8000/api/v1`.
 * - Sin variable en producción y dominio público → `/api/v1` (mismo origen; típico nginx/reverse proxy).
 */

function isPrivateLanIPv4(host) {
  if (!host || host === 'localhost' || host === '127.0.0.1') return false;
  if (/^192\.168\.\d{1,3}\.\d{1,3}$/.test(host)) return true;
  if (/^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(host)) return true;
  return /^172\.(1[6-9]|2\d|3[0-1])\.\d{1,3}\.\d{1,3}$/.test(host);
}

export function getApiV1Base() {
  const env = process.env.REACT_APP_API_URL;

  const pageHost =
    typeof window !== 'undefined' && window.location.hostname ? window.location.hostname : '';
  const onLoopback = pageHost === 'localhost' || pageHost === '127.0.0.1';
  const isDev = process.env.NODE_ENV !== 'production';
  const lanHost = isPrivateLanIPv4(pageHost);

  if (typeof env === 'string' && env.trim()) {
    const t = env.trim().replace(/\/$/, '');
    if (t.startsWith('/')) return t;

    if (!onLoopback && pageHost && /^https?:\/\/(localhost|127\.0\.0\.1)\b/i.test(t)) {
      try {
        const u = new URL(t);
        const port = u.port ? `:${u.port}` : '';
        return `${u.protocol}//${pageHost}${port}${u.pathname}`.replace(/\/$/, '');
      } catch {
        return t;
      }
    }
    return t;
  }

  if (typeof window !== 'undefined' && pageHost) {
    if (onLoopback) {
      return 'http://localhost:8000/api/v1';
    }
    // Misma red (dev o IP privada): API en el mismo host, puerto 8000.
    if (isDev || lanHost) {
      return `http://${pageHost}:8000/api/v1`;
    }
    // Producción sin REACT_APP_*: mismo origen (evita http://dominio-publico:8000 por error).
    return '/api/v1';
  }

  return 'http://localhost:8000/api/v1';
}

/** Origen del API sin /api/v1 (imágenes estáticas, uploads). */
export function getApiOrigin() {
  const v1 = getApiV1Base();
  if (v1.startsWith('/')) {
    if (typeof window !== 'undefined') return window.location.origin;
    return '';
  }
  return v1.replace(/\/api\/v1\/?$/i, '');
}
